/**
 * The deny screen's reasons (Figma 4:2, 4:192): `DenyHead` (the question and the line under it), `ReasonChips` (the
 * group of the nine reasons, each a toggle `Chip`, the chosen one dark) and `ReasonHelp` (what the chosen reason
 * means, on a raised ground). The words of every reason are the server's, never typed here.
 */
import type { ReactNode } from 'react';
import { RADIUS, SPACE, TEXT, WEIGHT, usePalette } from '../theme';

export function DenyHead({ title, note }: { title: ReactNode; note: ReactNode }) {
  const p = usePalette();
  return (
    <div style={{ display: 'flex', alignItems: 'baseline', gap: SPACE.sm, lineHeight: 'normal' }}>
      <h3 style={{ margin: 0, fontSize: TEXT.body, fontWeight: WEIGHT.strong, color: p.ink }}>{title}</h3>
      <span style={{ fontSize: TEXT.caption, color: p.inkMuted }}>{note}</span>
    </div>
  );
}

export function ReasonChips({ children, label }: { children: ReactNode; label: string }) {
  return (
    <div role="group" aria-label={label} style={{ display: 'flex', flexWrap: 'wrap', gap: SPACE.tight }}>
      {children}
    </div>
  );
}

export function ReasonHelp({ children }: { children: ReactNode }) {
  const p = usePalette();
  return (
    <div style={{ padding: `${SPACE.snug}px ${SPACE.md}px`, borderRadius: RADIUS.button, background: p.surfaceRaised, fontSize: TEXT.control, color: p.inkSecondary, lineHeight: 'normal' }}>
      {children}
    </div>
  );
}
